import { t } from '@lingui/macro';
import { getLazadaOauthLink } from 'api/api';
import BaseModal from 'component/BaseComponent/BaseModal.js';
import { handleApi } from 'helper/helper';
import React from 'react';
import Routes from 'router/routes.js';
import DV from 'variables/DV';
import Button from '../../MUI_Kit/components/CustomButtons/Button';

class RedirectToLazadaModal extends BaseModal {
  constructor(props) {
    super(props);
    this.showCloseButton = false;

    this.timer = 0;

    this.goPathWhenClose = Routes.channel.path;

    this.state = {
      open: false,
      time: 5,
      seconds: 5,
      ...this.getDataFromRouter(),
    };
  }

  async componentDidMount() {
    const { success } = await this.getOAuthUrl();
    if (!success) {
      return this.close();
    }
    this.setState({ time: this.state.seconds });
    this.startTimer();
  }

  getOAuthUrl = async () => {
    let { success, data, error } = await handleApi(getLazadaOauthLink());
    if (error) {
      DV.showNotify(error, 'danger');
      return { error };
    }
    if (success) {
      if (data.redirect_url) {
        await this.setState({ url: data.redirect_url, open: true });
      }
      return { success: true };
    }
  };

  startTimer = () => {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  countDown = () => {
    let seconds = this.state.seconds - 1;
    this.setState({
      time: seconds,
      seconds: seconds,
    });

    if (seconds === 0) {
      clearInterval(this.timer);
      window.location.href = this.state.url;
    }
  };

  renderBody() {
    return (
      <div>
        {t`Bạn sẽ được chuyển sang Lazada để tích hợp tài khoản Lazada với DooPage.`}
      </div>
    );
  }

  renderFooter() {
    return (
      <Button
        onClick={() => {
          window.location.replace(this.state.url);
        }}
        color="info">
        {t`CHUYỂN ĐẾN LAZADA` + ' (' + this.state.time + ')'}
      </Button>
    );
  }
}

export default RedirectToLazadaModal;
